import React, { useState,useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';


const SeleccionHembrasDash = (props) => {
  const [selectedAutoValue, setSelectedAutoValue] = useState(props.CHIP_MACHO);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState([]);
  const [reload, setReload] = useState(true)
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => { 
    async function traerUsuarios(NID_PROPIETARIO,ESPECIE,RAZA,SEXO,CHIP) {
      setReload(false)
    console.log("el chip es "+CHIP)
        if(CHIP==null || CHIP==undefined ) return
        const data = new FormData();
        data.append('NID_PROPIETARIO',NID_PROPIETARIO)
        data.append('COD_ESPECIE',ESPECIE)
        data.append('RAZA',RAZA)
        data.append('SEXO',SEXO)
        data.append('CHIP',CHIP)
      await fetch(APITABLASBASICAS + 'seleccionMachosDash', { 
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            //setReload(false)
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
    traerUsuarios(props.NID_PROPIETARIO,props.ESPECIE,props.RAZA,props.SEXO,props.CHIP)
}, [reload,props.NID_PROPIETARIO,props.ESPECIE,props.RAZA,props.SEXO,props.CHIP]);


  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};



  const handleChange = (event) => {
    setSelectedAutoValue(event)
    return props.handleplanta(event.code,16)
  };



  return (
    <div className="p-error">
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" />
    </div>
  );
};

export default SeleccionHembrasDash;
